export const environment = {
  production: false,
  cloudFunctionsApiUrl:
    'https://us-central1-the-campus-56b06.cloudfunctions.net/api',
  firebaseEmulators: null,
  firebase: {
    apiKey: 'AIzaSyBAzVs5MH7Mi58BbGKVUj1PtnaF_AebZ3o',
    authDomain: 'the-campus-56b06.firebaseapp.com',
    databaseURL: 'https://the-campus-56b06.firebaseio.com',
    projectId: 'the-campus-56b06',
    storageBucket: 'the-campus-56b06.appspot.com',
    messagingSenderId: '5270040003',
    appId: '1:5270040003:web:a6d570a94fa591f4872176',
    measurementId: 'G-83NSTQJ4NN',
  },
};
